/* eslint-disable react/no-deprecated */
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Divider } from '@material-ui/core';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ListSubheader from '@material-ui/core/ListSubheader';

import * as actions from '../../actions/index';
import { styles } from './MobileDesignConfig.styles';

import {
  initStates,
  changeDesignMobile,
  slideImage,
  depositImage,
  setCroppedSliderImage,
  handleRemoveSliderImage,
  handleCheckBox,
  handleSearchChange,
  handleSearchBlur, getSections
} from './MobileDesignConfig.services';
import facebookIcon from '../../assets/pictures/facebookIcon.png';
import instagramIcon from '../../assets/pictures/instagramIcon.png';
import linkedinIcon from '../../assets/pictures/linkedinIcon.png';
import { Button, Viewer, Paper, Input, Spinner, DraggableImage, Checkbox, SearchBar } from '..';
import { UNIT } from '../../constants';
import { TITLE_DESCRIPTION, CLIENT_SPACE, NEW_PRODUCTS_DESCRIPTION, LOYALTY_NAME } from '../../constants/dataConfig'
import RefreshIcon from '@material-ui/icons/Refresh';
import Tooltip from '@material-ui/core/Tooltip';
import { isObjectNotEmpty } from 'src/utils/tools';

const cropProps = {
  width: 'auto',
  height: UNIT * 10.6875,
  backgroundColor: '#F1F4F7',
  borderRadius: UNIT
}

const searchStyle = {
  border: '1px solid #E2E2E2',
  borderRadius: UNIT * 1.5,
  height: UNIT * 2.8125,
  marginBottom: UNIT * 0.5625
}

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}))(Tooltip);

function MobileDesignConfig(props) {
  const [searchTerm, setSearchTerm] = useState('')
  const [stateObj, setStateObjRaw] = useState({
    isLoading: false,
    loadingCropper: false,
    name: LOYALTY_NAME,
    newProductsDescription: NEW_PRODUCTS_DESCRIPTION,
    facebook: null,
    instagram: null,
    linkedin: null,
    titleDescription: TITLE_DESCRIPTION,
    clientSpace: CLIENT_SPACE,
    fedilityPicture: [],
    slidesPictures: [],
    products: [],
    myOrdersImage: [],
    myAccountImage: [],
    sections: [],
    allSections: [],
    isLoadingProducts: false,
    fedilityImage: [],
    slidesImages: [],
    myOrdersPicture: [],
    myAccountPicture: [],
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });
  const { classes, config, selected, onClick, renderFirstStepDesign, renderStyle } = props;

  useEffect(() => {
    initStates(props, setStateObj);
  }, [props]);

  useEffect(() => {
    async function fetchData() {
      if (config === 'Produits' && !isObjectNotEmpty(stateObj.sections)) {
        const response = await getSections(setStateObj);
        setStateObj({ sections: response, allSections: response })
      }
    }
    fetchData();
  }, [config]);



  // TODO Make all those functions an individual component
  const renderMedia = () => {
    const {
      loadingCropper,
      fedilityPicture = [],
      slidesPictures = [],
      myOrdersImage = [],
      myAccountImage = [],
      slidesImages = []
    } = stateObj;

    return (
      <div>
        <div>
          <p>
            <span className={classes.designText}>Slider</span> <i>(3 images maximum)</i>
          </p>
          {slidesPictures &&
            _.map(slidesPictures, (slider, index) => (
              <div className={classes.cropStyle}>
                <DraggableImage
                  multiple={false}
                  loadingCropper={loadingCropper}
                  disableLoader={() => setStateObj({ loadingCropper: false })}
                  maxFileSize={500000}
                  picture={!Array.isArray(slider) ? [{ imageUrl: slider }] : slider}
                  fileType
                  isDesign
                  setCroppedImage={croppedImage => setCroppedSliderImage(croppedImage, slidesImages, setStateObj, index)}
                  handleRemove={() => handleRemoveSliderImage(slidesImages, setStateObj, index)}
                  defaultText={"Drag & Drop l'image (500Ko max)"}
                  imgExtension={['.png', '.jpeg', '.jpg', 'jfif']}
                  cropProps={cropProps}
                  aspect={3}
                  cropStyle={classes.crop}
                />
              </div>
            ))}
        </div>
        <Divider className={classes.dividerStyle} />
        <div>
          <p>
            <span className={classes.designText}>Ma fidélité</span> <i>(1 image maximum)</i>
          </p>

          <div className={classes.cropStyle}>
            <DraggableImage
              multiple={false}
              loadingCropper={loadingCropper}
              disableLoader={() => setStateObj({ loadingCropper: false })}
              maxFileSize={500000}
              picture={
                !Array.isArray(fedilityPicture) ? [{ imageUrl: fedilityPicture }] : fedilityPicture
              }
              fileType
              isDesign
              setCroppedImage={croppedImage =>
                slideImage(croppedImage, setStateObj, 'fedilityImage')
              }
              handleRemove={() => depositImage(setStateObj, 'fedilityImage')}
              imgExtension={['.png', '.jpeg', '.jpg', 'jfif']}
              defaultText={"Drag & Drop l'image (500Ko max)"}
              cropProps={cropProps}
              aspect={3}
              cropStyle={classes.crop}
            />
          </div>
        </div>
        <Divider className={classes.dividerStyle} />
        <div>
          <p>
            <span className={classes.designText}>Mes commandes</span> <i>(1 image maximum)</i>
          </p>

          <div className={classes.myOrdersStyle}>
            <DraggableImage
              multiple={false}
              loadingCropper={loadingCropper}
              disableLoader={() => setStateObj({ loadingCropper: false })}
              maxFileSize={500000}
              picture={
                !Array.isArray(myOrdersImage) ? [{ imageUrl: myOrdersImage }] : myOrdersImage
              }
              fileType
              isDesign
              setCroppedImage={croppedImage => slideImage(croppedImage, setStateObj, 'myOrdersPicture')}
              handleRemove={() => depositImage(setStateObj, 'myOrdersPicture')}
              imgExtension={['.png', '.jpeg', '.jpg', 'jfif']}
              defaultText={"Drag & Drop l'image (500Ko max)"}
              cropProps={cropProps}
              aspect={1}
              cropStyle={classes.crop}
            />
          </div>
        </div>
        <Divider className={classes.dividerStyle} />
        <div>
          <p>
            <span className={classes.designText}>Mon profil</span> <i>(1 image maximum)</i>
          </p>

          <div className={classes.myOrdersStyle}>
            <DraggableImage
              multiple={false}
              loadingCropper={loadingCropper}
              disableLoader={() => setStateObj({ loadingCropper: false })}
              maxFileSize={500000}
              picture={
                !Array.isArray(myAccountImage) ? [{ imageUrl: myAccountImage }] : myAccountImage
              }
              fileType
              isDesign
              setCroppedImage={croppedImage =>
                slideImage(croppedImage, setStateObj, 'myAccountPicture')
              }
              handleRemove={() => depositImage(setStateObj, 'myAccountPicture')}
              imgExtension={['.png', '.jpeg', '.jpg', '.jfif']}
              defaultText={"Drag & Drop l'image (500Ko max)"}
              cropProps={cropProps}
              aspect={1}
              cropStyle={classes.crop}
            />
          </div>
        </div>
      </div >
    );
  };

  const renderText = () => {
    const { titleDescription, name, newProductsDescription, clientSpace } = stateObj;
    return (
      <div>
        <p className={classes.designText}>Titre d'accueil</p>

        <Input
          margin='dense'
          id='titleDescription'
          type='text'
          variant='outlined'
          value={titleDescription}
          onChange={e => setStateObj({ titleDescription: e.target.value })}
          className={classes.inputStyle}
          multiline
          InputProps={{
            classes: {
              input: classes.resize
            },
            endAdornment: titleDescription !== TITLE_DESCRIPTION && <InputAdornment position='end'>
              <LightTooltip title="Remettre la valeur par défaut">
                <RefreshIcon className={classes.iconColor} onClick={() => setStateObj({ titleDescription: TITLE_DESCRIPTION })} />
              </LightTooltip></InputAdornment>
          }}
          placeholder='Ex:Bienvenue chez...'

        />
        <p className={classes.designText}>Titre fidélité</p>

        <Input
          margin='dense'
          id='name'
          type='text'
          variant='outlined'
          value={name}
          onChange={e => setStateObj({ name: e.target.value })}
          className={classes.inputStyle}
          placeholder='Ex:Ma fidélité...'
          InputProps={{
            classes: {
              input: classes.resize
            },
            endAdornment: name !== LOYALTY_NAME && <InputAdornment position='end'>
              <LightTooltip title="Remettre la valeur par défaut"><RefreshIcon className={classes.iconColor} onClick={() => setStateObj({ name: LOYALTY_NAME })} /></LightTooltip>
            </InputAdornment>
          }}
          multiline
        />
        <p className={classes.designText}>Titre produits en avant</p>

        <Input
          margin='dense'
          id='newProductsDescription'
          type='text'
          variant='outlined'
          value={newProductsDescription}
          onChange={e => setStateObj({ newProductsDescription: e.target.value })}
          className={classes.inputStyle}
          placeholder='Ex:Nos derniéres nouveautés...'
          InputProps={{
            classes: {
              input: classes.resize
            },

            endAdornment: newProductsDescription !== NEW_PRODUCTS_DESCRIPTION && <InputAdornment position='end'>
              <LightTooltip title="Remettre la valeur par défaut"><RefreshIcon className={classes.iconColor} onClick={() => setStateObj({ newProductsDescription: NEW_PRODUCTS_DESCRIPTION })} /></LightTooltip>
            </InputAdornment>
          }}
          multiline
        />
        <p className={classes.designText}>Espace client</p>

        <Input
          margin='dense'
          id='clientSpace'
          type='text'
          variant='outlined'
          value={clientSpace}
          onChange={e => setStateObj({ clientSpace: e.target.value })}
          className={classes.inputStyle}
          placeholder='Ex:Mon espace client'
          InputProps={{
            classes: {
              input: classes.resize
            },

            endAdornment: clientSpace !== CLIENT_SPACE && <InputAdornment position='end'>
              <LightTooltip title="Remettre la valeur par défaut"><RefreshIcon className={classes.iconColor} onClick={() => setStateObj({ clientSpace: CLIENT_SPACE })} /></LightTooltip>
            </InputAdornment>
          }}
          multiline
        />
      </div>
    );
  };

  const renderProduct = () => {
    const { products, sections } = stateObj;
    const produits = [];
    _.map(sections, section => {
      _.map(section.products, elt => {
        produits.push({ sectionKey: section?.name?.toUpperCase(), ...elt });
      });
    });
    const filtredProducts = produits.sort((a, b) => -b.sectionKey.localeCompare(a.sectionKey));
    return (
      <>
        <SearchBar
          value={searchTerm}
          label='Chercher un produit...'
          onChange={e => handleSearchChange(e, setStateObj, setSearchTerm, stateObj)}
          onBlur={() => handleSearchBlur(setStateObj, searchTerm, stateObj)}
          onClick={() => handleSearchBlur(setStateObj, searchTerm, stateObj)}
          style={searchStyle}
        />
        {stateObj.isLoadingProducts ?
          <div className={classes.loadingProduct}>
            <Spinner />
          </div> :
          <List className={classes.root} subheader={<li />}>
            {_.map(sections, section => (
              <li key={section.key} className={classes.listSection}>
                <ListSubheader className={classes.listHeaderStyle}>
                  {section?.name?.toUpperCase()}
                </ListSubheader>
                {_.map(
                  _.filter(filtredProducts, elm => elm.sectionKey === section?.name?.toUpperCase()),
                  item => (
                    < ListItem key={item.key} >
                      <Checkbox
                        value={Object.values(products).some(product => product.key === item.key)}
                        onClick={() => handleCheckBox(products, setStateObj, item)}
                        text={item.name}
                        className={classes.textStyle}
                      />
                    </ListItem>
                  )
                )}
              </li>
            ))}
          </List>
        }
      </>
    );
  };

  const renderLink = () => {
    const { facebook, instagram, linkedin, url } = stateObj;
    return (
      <div>
        <p className={classes.designText}>Site web</p>
        <Input
          margin='dense'
          multiline
          id='url'
          type='text'
          variant='outlined'
          value={url || ''}
          onChange={e => setStateObj({ url: e.target.value })}
          className={classes.inputStyle}
          placeholder='https://www.webapp.fr/..'
          InputProps={{
            classes: {
              input: classes.resize
            },
            startAdornment: (
              <InputAdornment position='start'>
                <LanguageOutlinedIcon style={{ opacity: 0.5 }} />
              </InputAdornment>
            )
          }}
        />
        <p className={classes.designText}>Facebook</p>
        <Input
          margin='dense'
          multiline
          id='facebook'
          type='text'
          variant='outlined'
          value={facebook || ''}
          onChange={e => setStateObj({ facebook: e.target.value })}
          className={classes.inputStyle}
          placeholder='https://www.facebook.com/..'
          InputProps={{
            classes: {
              input: classes.resize
            },
            startAdornment: (
              <InputAdornment position='start'>
                <img src={facebookIcon} alt='displayImage' className={classes.iconOpacity} />
              </InputAdornment>
            )
          }}
        />
        <p className={classes.designText}>Instagram</p>
        <Input
          margin='dense'
          multiline
          id='instagram'
          type='text'
          variant='outlined'
          value={instagram || ''}
          onChange={e => setStateObj({ instagram: e.target.value })}
          className={classes.inputStyle}
          placeholder='https://www.instagram.com/..'
          InputProps={{
            classes: {
              input: classes.resize
            },
            startAdornment: (
              <InputAdornment position='start'>
                <img src={instagramIcon} alt='displayImage' className={classes.iconOpacity} />
              </InputAdornment>
            )
          }}
        />
        <p className={classes.designText}>LinkedIn</p>
        <Input
          multiline
          margin='dense'
          id='linkedin'
          type='text'
          variant='outlined'
          value={linkedin || ''}
          onChange={e => setStateObj({ linkedin: e.target.value })}
          className={classes.inputStyle}
          placeholder='https://www.linkedIn.com/..'
          InputProps={{
            classes: {
              input: classes.resize
            },
            startAdornment: (
              <InputAdornment position='start'>
                <img src={linkedinIcon} alt='displayImage' className={classes.iconOpacity} />
              </InputAdornment>
            )
          }}
        />
      </div>
    );
  };

  const renderDesign = () => {
    if (config === 'Médias') {
      return renderMedia();
    }
    if (config === 'Texte') {
      return renderText();
    }
    if (config === 'Produits') {
      return renderProduct();
    }
    if (config === 'Liens') {
      return renderLink();
    }
  };

  const { sections } = stateObj
  const produits = [];
  _.map(sections, section => {
    _.map(section.products, elt => {
      produits.push({ sectionKey: section?.name?.toUpperCase(), ...elt });
    });
  });

  return (
    <>
      {config === '' ? (
        <>
          <Paper className={classes.paperStyle}>
            <Viewer value={selected} onChange={onClick} selectedEntity={selected} buttonList={['Config', 'Style']} />
          </Paper>
          <div className={classes.container}>
            {selected === 0 ? <div>{renderFirstStepDesign}</div> : <div className='p-3'>{renderStyle}</div>}
          </div>
        </>

      ) : (

        <div className={`p-4 ${classes.containerStyle} `}>{renderDesign()}</div>
      )}{' '}
      {(config !== '' || selected === 1) && (
        <div className='d-flex justify-content-center m-3 '>
          {stateObj.isLoading ? (
            <center>
              <Spinner className={classes.progress} />
            </center>
          ) : (
            <Button onClick={() => changeDesignMobile(stateObj, produits, setStateObj, props)} className={classes.buttonStyle}>
              ENREGISTRER
            </Button>
          )}
        </div>)}
    </>
  );

}

function mapStateToProps({ firebaseRealTime }) {
  const { generalConfig = {}, shops } = firebaseRealTime;
  const {
    images = {},
    socials = {},
    mobileApp = {},
    url,
    newProducts = {},
    loyalty = {}
  } = generalConfig;
  const { titleDescription, clientSpace } = mobileApp;
  const { facebook, instagram, linkedin } = socials;
  const { myLoyalty, slides, myAccount, myOrders } = images;
  const { design, newProductsDescription } = mobileApp;
  const { name } = loyalty;
  return {
    facebook,
    instagram,
    linkedin,
    titleDescription,
    clientSpace,
    myLoyalty,
    slides,
    url,
    shops,
    newProducts,
    design,
    name,
    newProductsDescription,
    myAccount,
    myOrders,
    generalConfig
  };
}

export default connect(
  mapStateToProps,
  actions
)(withStyles(styles)(withRouter(MobileDesignConfig)));
